/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import "components/elements/main/index.scss";

import UserCombinedSearch from "components/widgets/user/UserCombinedSearch";
import UserProductPopularSlider from "components/elements/user/products/UserProductPopularSlider";
import UserProductNewSlider from "components/elements/user/products/UserProductNewSlider";
import UserOffersFavNearbySlider from "components/elements/user/offers/UserOffersFavNearbySlider";
import UserOffersNearbySlider from "components/elements/user/offers/UserOffersNearbySlider";
import UserOffersLatestSlider from "components/elements/user/offers/UserOffersLatestSlider";
import UserShopsNearSlider from "components/elements/user/shops/UserShopsNearSlider";
import UserShopsPopularSlider from "components/elements/user/shops/UserShopsPopularSlider";
import UserShopsLatestSlider from "components/elements/user/shops/UserShopsLatestSlider";
import UserProductCategorySlider from "components/elements/user/products/UserProductCategorySlider";
import UserShopLocationSlider from "components/elements/user/UserShopLocationSlider";
import UserShopsExactLocationSlider from "components/elements/user/shops/UserShopsExactLocationSlider";

const UserHomeMain = (props) => {
  const [state, setState] = useState({
    layoutColumns: 3,
  });

  useEffect(() => {
    document.getElementById("color").setAttribute("href", "#");
  }, []);

  return (
      <div>
          <UserCombinedSearch {...props} colSize={state.layoutColumns} />

          <UserProductCategorySlider isDirect={true} includeAll={false} {...props} />

          <UserProductPopularSlider />

          {/* <UserShopLocationSlider isDirect={true} isProduct={true} {...props} /> */}

          <UserShopsPopularSlider />

          {localStorage.getItem("isAuthorized") &&
          <UserOffersFavNearbySlider />}

          <UserShopsNearSlider />

          {/* <UserShopLocationSlider isDirect={true} isProduct={false} {...props} /> */}

          <UserOffersNearbySlider />

          <UserProductNewSlider />

          <UserShopsLatestSlider />

          <UserOffersLatestSlider />

          <UserShopsExactLocationSlider />

      </div>
  );
};

export default UserHomeMain;
